/* jslint esversion: 6 */
/**
 * Menu Header
 *
 * @author Dylan James Wagner
 */
const $ = window.jQuery;
const s = {
	menuItems: $('.menu--header .menu__list > .menu-item-has-children'),
};

function init() {
	events();
}

function events() {

	s.menuItems.on('focusin focusout', function() {
		toggleMenu($(this));
	});
}

function toggleMenu($element) {

	if ($element.attr('aria-expanded') === 'true') {
		$element.attr('aria-expanded', 'false');
	}
	else {
		$element.attr('aria-expanded', 'true');
	}
}

export {init as default};
